'use client'

import * as React from 'react'
import { LoadMoreTrigger } from '@web/components/algolia/components/content-search-results/list-products'
import { SpinnerFasIcon } from '@web/components/icons/spinner-fas'

/** Temporary: Dutch homepage grid loads one page so users can reach the footer. */
export function isHomepageInfiniteScrollEnabled(locale: string) {
  return locale !== 'nl'
}

export function HomeProductsPaginationFooter({
  infiniteScrollEnabled,
  canFetchNextPageRef,
  infiniteProductsAreLoading,
  infiniteProductsAreFetching,
  fetchNextPage,
  hasNextPage,
  productsLength,
  loadingLabel,
  noMoreProducts,
}: {
  infiniteScrollEnabled: boolean
  canFetchNextPageRef: React.RefObject<HTMLDivElement | null>
  infiniteProductsAreLoading: boolean
  infiniteProductsAreFetching: boolean
  fetchNextPage: () => void
  hasNextPage: boolean | undefined
  productsLength: number
  loadingLabel: string
  noMoreProducts: React.ReactNode
}) {
  if (!infiniteScrollEnabled) {
    return null
  }

  const showNoMoreProducts =
    productsLength > 0 &&
    !hasNextPage &&
    !infiniteProductsAreLoading &&
    !infiniteProductsAreFetching

  return (
    <>
      <div ref={canFetchNextPageRef} />
      {infiniteProductsAreLoading || infiniteProductsAreFetching ? (
        <div className="text-gray-purple-300 mt-5 h-full w-full text-center">
          <SpinnerFasIcon className="mr-3 inline size-8 animate-spin" />
          <span className="text-20">{loadingLabel}</span>
        </div>
      ) : (
        <LoadMoreTrigger
          showMore={fetchNextPage}
          canLoadMore={productsLength > 0 ? !!hasNextPage : false}
        />
      )}
      {showNoMoreProducts ? noMoreProducts : null}
    </>
  )
}
